import React from 'react'
import styles from './NotFoundPage.module.css'

function NotFoundPage() {
  return (
    <div className={styles.NotFound}>
      <h1>404 - Not Found</h1>
    </div>
  )
}

export default NotFoundPage